import {
  defaultTo,
  dissoc,
  F,
  find,
  findIndex,
  map,
  modify,
  path,
  prop,
  propEq,
  propSatisfies,
  when
} from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useState } from 'react';

import useSaveSouscriptionPricingMutation from './useSaveSouscriptionPricingMutation.js';
import { useForm } from 'react-hook-form';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';

const useSouscriptionPricingForm = ({ project }) => {
  const [loading, setLoading] = useState(false);
  const { processHandlers, context } = useProcess();
  const { onFormSubmit } = useSaveSouscriptionPricingMutation();
  const [displayError, setDisplayError] = useState(false);

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      offer: prop('offer', project),
      paymentInformations: {
        paymentFrequency: 'MONTHLY'
      }
    }
  });

  const packs = defaultTo([], form.watch('offer.packs'));
  const pricings = defaultTo([], form.watch('offer.packs.0.pricings'));

  const $onPrevClick = () => {
    processHandlers.onPrev({ context: { projectId: context?.projectId } });
  };

  const onSubmit = (values) => {
    if (selectedModuleCode) {
      if (loading) return;
      setLoading(true);
      onFormSubmit(dissoc('paymentInformations', values), (ok, error) => {
        if (ok && !error) {
          processHandlers.onNext({
            context: {
              projectId: context?.projectId
            }
          });
        } else {
          setLoading(false);
        }
      });
    } else {
      setDisplayError(true);
      return setTimeout(() => setDisplayError(false), 3000);
    }
  };

  const [selectedModuleCode, setSelectedModuleCode] = useState(
    find(prop('isSelected'), pricings)?.moduleCode
  );

  const onSelect = (pricingCode) => {
    const pricingIndex = findIndex(propEq('moduleCode', pricingCode), pricings);
    const pricingSelected = path([pricingIndex, 'isSelected'], pricings);

    const unselectedPricings = map(
      when(propSatisfies(isNilOrEmpty, 'supplementaryCover'), modify('isSelected', F))
    )(pricings);
    form.setValue('offer.packs.0.pricings', unselectedPricings);
    form.setValue(`offer.packs.0.pricings.${pricingIndex}.isSelected`, !pricingSelected);
    setSelectedModuleCode(pricingCode);
  };

  return {
    form,
    $onPrevClick,
    onSubmit,
    displayError,
    onSelect,
    selectedModuleCode,
    pricings,
    packs
  };
};

export default useSouscriptionPricingForm;
